import { render, staticRenderFns } from "./ShopChooseDialog.vue?vue&type=template&id=236c54e7&scoped=true"
import script from "./ShopChooseDialog.vue?vue&type=script&lang=js"
export * from "./ShopChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./ShopChooseDialog.vue?vue&type=style&index=0&id=236c54e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c54e7",
  null
  
)

export default component.exports